import { PromotionsActionTypes, PromotionsMutationTypes } from './types';
import { notifySuccess, notifyError } from '../../helpers/notifications';

const fail = (body, fallback) => {
    notifyError({
        title: (body && body.error_message) || fallback,
        errors: body && body.errors,
    });
};

const saved = (body) => Boolean(body && body.data && !body.error_message);

export const actions = {
    async [PromotionsActionTypes.GetPromotions]({ commit }, { params } = {}) {
        const response = await this.$api.getPromotions.get({
            params: { ...params },
        });
        const body = response && response.data;
        if (body && body.data) {
            commit(PromotionsMutationTypes.SetPromotions, { promotions: body.data });
            return body;
        }
        fail(body, 'Не удалось получить акции');
        return null;
    },
    async [PromotionsActionTypes.AddPromotion](context, { data } = {}) {
        const response = await this.$api.addPromotion.post({
            body: { ...data },
        });
        const body = response && response.data;
        if (saved(body)) {
            notifySuccess({ title: body.message });
            return body;
        }
        fail(body, 'Не удалось создать акцию');
        throw new Error((body && body.error_message) || 'add promotion');
    },
    async [PromotionsActionTypes.EditPromotion]({ commit }, { id, value }) {
        const response = await this.$api.editPromotion.update({
            id,
            body: { ...value },
        });
        const body = response && response.data;
        if (saved(body)) {
            commit(PromotionsMutationTypes.SetChangedPromotion, { promotion: body.data });
            notifySuccess({ title: body.message });
            return body;
        }
        fail(body, 'Не удалось изменить акцию');
        throw new Error((body && body.error_message) || 'edit promotion');
    },
    async [PromotionsActionTypes.DeletePromotion]({ commit }, { id }) {
        const response = await this.$api.deletePromotion.remove({ id });
        const body = response && response.data;
        if (body && !body.error_message) {
            commit(PromotionsMutationTypes.SetDeletedPromotion, { id });
            notifySuccess({ title: body.message });
            return body;
        }
        fail(body, 'Не удалось удалить акцию');
    },
};
